import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    // TODO: Replace with a proper loading component
    return (
      <div className="min-h-screen bg-[#111418] flex items-center justify-center">
        <div className="text-[#f0f4f8]">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to home page, saving the attempted location
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;